// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"996":"55134b0db6000f7d","997":"78045b8d9082e225"}[chunkId] + ".js";
};